import React, { useState, useRef } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/sections/HeroSection';
import { RankingsSection } from '@/components/sections/RankingsSection';
import { AboutSection } from '@/components/sections/AboutSection';
import { ContactSection } from '@/components/sections/ContactSection';
import { CountriesSection } from '@/components/sections/CountriesSection';

const HomePage = () => {
  const [activeSection, setActiveSection] = useState('home');
  
  const rankingsRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  const handleNavigate = (sectionId) => {
    setActiveSection(sectionId);
    
    const scrollToSection = (ref) => {
      if (ref?.current) {
        const headerOffset = 80;
        const elementPosition = ref.current.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    };

    switch (sectionId) {
      case 'home':
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'rankings':
        scrollToSection(rankingsRef);
        break;
      case 'about':
        scrollToSection(aboutRef);
        break;
      case 'contact':
        scrollToSection(contactRef);
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header activeSection={activeSection} onNavigate={handleNavigate} />
      
      <main>
        {/* Hero Section */}
        <HeroSection onNavigate={handleNavigate} />
        
        {/* Countries Quick Links */}
        <CountriesSection onNavigate={handleNavigate} />
        
        {/* Rankings Section */}
        <div ref={rankingsRef}>
          <RankingsSection />
        </div>
        
        {/* About Section */}
        <div ref={aboutRef}>
          <AboutSection />
        </div>
        
        {/* Contact Section */}
        <div ref={contactRef}>
          <ContactSection />
        </div>
      </main>
      
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
